import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserEditPage } from './user-edit';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		UserEditPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(UserEditPage),
	],
})
export class UserEditPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-edit/user-edit.module.ts